import React, { useState, useEffect } from "react";
import { useTable, useSortBy } from "react-table";

import { LoadingSpinner } from "../partials/LoadingSpinner";
import { Pager } from "../Pager/Pager";
import {
  API_URL,
  GET_SALES_REPORT_DETALIZATION,
  SALES_DETALIZATION_COLUMNS,
} from "../../../constants";
import { GET_TOKEN, CURRENCY } from "../../../helpers";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./WidgetTableSalesDetalization.css";

export const WidgetTableSalesDetalization = (props) => {
  const [fullSalesDetalizationData, setFullSalesDetalizationData] = useState({});
  const [salesDetalizationData, setSalesDetalizationData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageCount, setMaxPageCount] = useState(1);
  const [dataLoaded, setDataLoaded] = useState(false);

  const currentPageSetter = (e) => {
    setCurrentPage(parseInt(e.target.getAttribute("value")));
  };

  const currentPageSetterIncrease = () => {
    currentPage < maxPageCount && setCurrentPage(currentPage + 1);
  };

  const currentPageSetterDecrease = () => {
    currentPage > 1 && setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    setDataLoaded(false);
    let hasDates = props?.filterPayload?.from || props?.filterPayload?.to;

    const generateString = () => {
      let result = "/?";

      const querryString = {
        offset: (currentPage - 1) * 25,
        limit: 25,
        from:
            (props.filterPayload && props.filterPayload.from) &&
            props.filterPayload.from.getFullYear() +
            "-" +
            ( props.filterPayload.from.getMonth() + 1) +
            "-" +
            props.filterPayload.from.getDate(),
        to:
            (props.filterPayload && props.filterPayload.to) &&
            props.filterPayload.to.getFullYear() +
            "-" +
            ( props.filterPayload.to.getMonth() + 1) +
            "-" +
            props.filterPayload.to.getDate(),
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined) {
          return (result = result.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return result;
    };

    fetch(
      API_URL + 
      GET_SALES_REPORT_DETALIZATION + 
      generateString() +
      `region=${props.countryFilter || 'all'}&` +
      ((props.globalDays && !hasDates) ? `days=${props.globalDays}&` : '') + 
      (props.globalCurrency && `currency=${props.globalCurrency}&`), 
      {
        method: "get",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => setFullSalesDetalizationData(response))
      .then(() => setDataLoaded(true));
  }, [currentPage, props.globalCurrency, props.globalDays, props.countryFilter, props.filterPayload]);


  // After Filter update initiate new data fetch
  useEffect(() => {
    if (fullSalesDetalizationData.result) {
      setSalesDetalizationData(fullSalesDetalizationData.result);
      setMaxPageCount(fullSalesDetalizationData.pages);
    }
  //eslint-disable-next-line
  }, [fullSalesDetalizationData]);

  const sumOfGrossValue = () => {
    let totalAmmount = 0;

    salesDetalizationData.map((item) => {
      return (totalAmmount += item.grossvalue);
    });

    return totalAmmount.toFixed(2);
  };

  const columns = SALES_DETALIZATION_COLUMNS;
  const Table = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

    return (
      <>
        <table {...getTableProps()} className="default-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <React.Fragment key={column.id}>
                    {column.Header !== "" && (
                      <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                    )}
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              let flagURL = '';
              let vatMessage = '';

              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    if (
                      cell.column.id === "netvalue" ||
                      cell.column.id === "vatonsales" ||
                      cell.column.id === "grossvalue"
                    ) {
                      return (
                        <td {...cell.getCellProps()}>
                          {(cell.value &&
                            CURRENCY(cell.value, cell.row.original.currency_symbol)) ||
                            0}
                        </td>
                      );
                    } else if (cell.column.id === "vatrate") {
                      return (
                        vatMessage.length > 0 
                        ? ( 
                          <td {...cell.getCellProps()}>
                            {vatMessage}
                          </td>
                        )
                        : <td {...cell.getCellProps()}>
                          {cell.render("Cell")} %
                        </td>
                      );
                    } else if (cell.column.id === "region") {
                      return (
                        <td {...cell.getCellProps()}>
                          <div className="flex-align-center">
                            {flagURL && (
                              <img
                                src={flagURL}
                                className="flag-icon-img"
                                alt={cell.value}
                              />
                            )}
                            {cell.render("Cell")}
                          </div>
                        </td>
                      );
                    } else if (cell.column.id === "img") {
                        flagURL = cell.value
                        return;
                    }
                     else if (cell.column.id === "vat_message") {
                        vatMessage = cell.value
                        return;
                    }
                  
                    else {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    }
                  })}
                </tr>
              );
            })}

            <tr className="total-row" role="row">
              <td role="cell"></td>
              <td role="cell"></td>
              <td role="cell"></td>
              <td className="total-value" role="cell" colSpan="2">
                <span>Grand total</span> {sumOfGrossValue()}
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </>
    );
  };

  // vat_message

  return (
    <div className="widgetTableSalesDetalization widget">
      <h2> Sales detalization </h2>

      {salesDetalizationData.length > 0 && dataLoaded === true ? (
        <>
          <Table columns={columns} data={salesDetalizationData} />

          {maxPageCount > 1 && (
            <Pager
              currentPage={currentPage}
              maxPageCount={maxPageCount}
              currentPageSetter={currentPageSetter}
              currentPageSetterIncrease={currentPageSetterIncrease}
              currentPageSetterDecrease={currentPageSetterDecrease}
            />
          )}
        </>
      ) : dataLoaded 
          ? <EmptyData title="No sales data in selected period found" />
          : <LoadingSpinner/>
      }
    </div>
  );
};
